const LIGHT = {
  bg:           "#f7f7f6",
  surface:      "#ffffff",
  surfaceAlt:   "#f2f2f0",
  border:       "#e4e4e1",
  borderStrong: "#c8c8c4",
  text:         "#111110",
  textSub:      "#6b6b67",
  textDim:      "#b0b0aa",
  ink:          "#111110",
  inkText:      "#ffffff",
  nav:          "#fafaf9",
  topbar:       "#ffffff",
  green:        "#1a7a42",
  greenBg:      "#edf7f1",
  greenBorder:  "#b6dfc6",
  amber:        "#8a5f0a",
  amberBg:      "#fdf5e6",
  amberBorder:  "#e8d09a",
  red:          "#8b1f1f",
  redBg:        "#fdf0f0",
  redBorder:    "#e8b4b4",
  grey:         "#6b6b67",
  greyBg:       "#f2f2f0",
  greyBorder:   "#d4d4d0",
  blue:         "#1d4e8a",
  blueBg:       "#eef3fb",
  blueBorder:   "#b8cfe8",
};

const DARK = {
  bg:           "#0d0f17",
  surface:      "#141720",
  surfaceAlt:   "#1a1d2a",
  border:       "#252836",
  borderStrong: "#343748",
  text:         "#e8eaf0",
  textSub:      "#8b8fa8",
  textDim:      "#4a4e63",
  ink:          "#e8eaf0",
  inkText:      "#0d0f17",
  nav:          "#111420",
  topbar:       "#111420",
  green:        "#34d474",
  greenBg:      "#0d2b1a",
  greenBorder:  "#1a5c35",
  amber:        "#f5a623",
  amberBg:      "#2b1f0a",
  amberBorder:  "#5c3d12",
  red:          "#f06565",
  redBg:        "#2b0f0f",
  redBorder:    "#5c2020",
  grey:         "#8b8fa8",
  greyBg:       "#1a1d2a",
  greyBorder:   "#343748",
  blue:         "#5b9cf6",
  blueBg:       "#0f1d36",
  blueBorder:   "#1e3d6e",
};

export const THEMES = { light: LIGHT, dark: DARK };

// T is kept for dynamic runtime color maps (e.g. Badge)
export let T = { ...LIGHT };

export const setTheme = (mode) => {
  const tokens = mode === "dark" ? DARK : LIGHT;
  Object.assign(T, tokens);
  const root = document.documentElement;
  root.setAttribute("data-theme", mode);
  Object.entries(tokens).forEach(([key, val]) => {
    const cssVar = "--" + key.replace(/([A-Z])/g, (m) => "-" + m.toLowerCase());
    root.style.setProperty(cssVar, val);
  });
};
